export class GlobalChanges {
    globalSettingsChanged = false;
}



// WEBPACK FOOTER //
// ./src/app/settings/models/global-changes.model.ts